import React, { useEffect, useState } from 'react';
import { SettingsStyles } from './Settings.styles';
import { Switch } from '@mui/material';
import { useDispatch } from 'react-redux';
import { changeMode } from 'redux/features/LoginSlice';
import { useTranslation } from 'react-i18next';
import { CloseIcon } from 'components';
import useWindowDimensions from 'components/Dimention';
import { swipeModalWidth } from 'utils/helper';
import { useNavigate } from 'react-router-dom';

export default function DisplaySetting() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { width } = useWindowDimensions();
  const isSmallScreen = width <= swipeModalWidth;

  const [checked, setChecked] = useState(true);

  const currentTheme = localStorage.getItem('mode');

  useEffect(() => {
    if (currentTheme === 'Dark') {
      setChecked(true);
    }
  }, [currentTheme]);

  const handleChange = (event) => {
    localStorage.setItem('mode', currentTheme === 'Dark' ? 'Light' : 'Dark');
    dispatch(changeMode(currentTheme === 'Dark' ? 'Light' : 'Dark'));
    setChecked(event.target.checked);
  };

  return (
    <SettingsStyles>
      <div className="setting-info-container">
        <div className="setting-title">
        {isSmallScreen && (
            <CloseIcon
              customStyle="back-icon"
              iconType="back"
              onClick={() => navigate('/settings')}
            />
          )}
          {t('Settings.Display')}</div>
        <div className="accept-request-label">
          <div>
            <div className='setting-help-title'>{t('Settings.DarkMode')}</div>
            <div className="accept-request-helper">
            {t('Settings.ChooseThemeText')}
            </div>
          </div>
          <Switch
            checked={checked}
            onChange={handleChange}
            inputProps={{ 'aria-label': 'controlled' }}
          />
        </div>
      </div>
    </SettingsStyles>
  );
}
